"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('../../../sass/components/shared/Trademark.css');

var currentYear = new Date().getFullYear();

var _default = function _default() {
  return /*#__PURE__*/_react.default.createElement("p", {
    className: "footer-desc"
  }, currentYear, " Everdays Inc. All rights reserved. The Everdays marks and the Everdays logo are trademark of Everdays Inc.");
};

exports.default = _default;